export const QueueReportStatuses = Object.freeze({
  Pending: 1,
  Running: 2,
  Completed: 3,
  Failed: 7
})
